import { getApi, postApi } from "./utils";

export const getYears = () => {
  return getApi("ex/years");
};

export const getBrands = ({ year }) => {
  return getApi("ex/brands", {
    year: year,
  });
};

export const getModels = ({ year, brand }) => {
  return getApi("ex/models", {
    year: year,
    brand_id: brand,
  });
};

export const getVariants = ({ model, year, fuel_type, transmission_type }) => {
  return getApi(`ex/models/${model}/variants`, {
    year: year,
    fuel_type: fuel_type,
    transmission_type: transmission_type,
  });
};

export const postExchangeAPI = ({
  lead_id,
  model_id,
  variant_id,
  dealer_id,
  showroom_id,
  ex_model_id,
  ex_variant_id,
  year,
  registration_number,
  no_of_owners,
  kms_driven,
  insurance_type,
}) => {
  return postApi(`exchanges`, {
    lead_id,
    model_id,
    variant_id,
    dealer_id,
    showroom_id,
    ex_model_id,
    ex_variant_id,
    year,
    registration_number,
    no_of_owners,
    kms_driven,
    insurance_type,
  });
};
